import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Typography, IconButton } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import RecordButtonOpen from "../../Components/Media/RecordButtonOpen";
import SmartCheckCardOpen from "../../Components/Card/AssetUI/SmartCheckCardOpen";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import AITestGuestInfo from "../../Components/Modal/AITestGuestInfo";
import { userLogs } from "../../Js/Common";
import uuid from "react-uuid";
import html2pdf from "html2pdf.js";
import { twoDigit } from "../../Js/TimeAndDate";
import { updateLog } from "./Services";
import TimerIcon from "@mui/icons-material/Timer";
import { audioSmartCheckUnScripted } from "../../Js/Common";

const AITest = (props) => {
  const navigation = useNavigate();
  const classes = useStyles();
  let [userAnswer, setUserAnswer] = useState([]);
  let [localAudios, setLocalAudios] = useState([]);
  let [currentOptionIndex, setCurrentOptionIndex] = useState(0);
  let [smartCheckResult, setSmartCheckResult] = useState([]);
  let [isPlaying, setIsPlaying] = useState(false);
  let [currentIndexPlay, setCurrentIndexPlay] = useState([]);
  let [unscripted, setUnscripted] = useState(true);
  let [currentRecord, setCurrentRecord] = useState(false);
  let [aiEnable, setAiEnable] = useState(true);
  let [infoModl, setInfoModl] = useState(true);
  let [savedLogId, setSavedLogId] = useState(null);
  let [userData, setUserData] = useState({});
  let [timerClock, setTimerClock] = useState(30);
  let [interval1, setInterval1] = useState(null);
  let [hidePronoun, setHidePronoun] = useState(false);

  const setAudioLinks = (audioLink, index) => {
    let newArray = [...localAudios];
    newArray[index] = audioLink;
    setLocalAudios(newArray);
  };

  const setSmartCheck = async (result, filename, index) => {
    let newArray1 = [...userAnswer];
    newArray1[index] = filename;
    setUserAnswer(newArray1);

    let newArray = [...smartCheckResult];
    let updateFlag = true;
    if (
      newArray[index] &&
      !unscripted &&
      +newArray[index]["utterance"][0]["nativeness_score"] >
        result["utterance"][0]["nativeness_score"]
    ) {
      updateFlag = false;
    }

    newArray[index] = result;
    console.log("newArray", newArray);
    setSmartCheckResult(newArray);
    let saveResult = await updateLog(
      {
        outcome: newArray,
      },
      "fe7704fd-8186-4075-838e-f7a47f7eaf06",
      savedLogId
    );
    console.log("SSS", saveResult);
  };

  const setFiles = (filename, index) => {
    let newArray = [...userAnswer];
    newArray[index] = filename;
    setUserAnswer(newArray);
  };

  const saveData = async (data) => {
    setUserData(data);
    let logResponse = await userLogs({
      actor: "9f13f0b8-4163-4dc7-8d85-a0f8b11c6edd",
      site_uuid: "fe7704fd-8186-4075-838e-f7a47f7eaf06",
      verb: "guestInfo",
      context: {
        ...data,
        email_send: false,
        phone_send: false,
      },
      session_uid: uuid(),
    });
    if (logResponse.data && logResponse.data.uid) {
      setSavedLogId(logResponse.data["uid"]);
      setInfoModl(false);
    }
  };

  const downloadPDF = () => {
    if (
      smartCheckResult &&
      smartCheckResult.length > 0 &&
      smartCheckResult[0] &&
      aiEnable
    ) {
      var element = document.getElementById("pdfid");
      var opt = {
        margin: [20, 15, 0, 0],
        filename: `report_${userData.name}.pdf`,
        jsPDF: {
          unit: "pt",
          format: "a4",
          orientation: "landscape",
        },
        pagebreak: { mode: ['css', 'legacy'] }
      };
      //html2pdf(element,opt);
      html2pdf().from(element).set(opt).toPdf().save();
    }
  };

  const startInterval = (flg) => {
    let temp;
    if (flg) {
      console.log("flg1", flg);
      setInterval1(
        setInterval(() => {
          setTimerClock((val) => val - 1);
        }, 1000)
      );
      setTimeout(() => {
        clearInterval(interval1);
        setTimerClock(0);
      }, 30000);
    } else {
      console.log("flg2", flg);
      clearInterval(interval1);
      setTimerClock(0);
    }
  };

  const fileChange = async () => {
    const file = document.getElementById("uploadaudio").files[0];
    file.arrayBuffer().then(async (buffer) => {
      const blob = new Blob([buffer], { type: file.type });
      console.log("blob", file);
      let response = await audioSmartCheckUnScripted(
        file,
        false,
        "9f13f0b8-4163-4dc7-8d85-a0f8b11c6edd",
        "fe7704fd-8186-4075-838e-f7a47f7eaf06"
      );
      if (!response.error) {
        console.log("response.smartCheck.data", response.smartCheck.data);
        setSmartCheck(response.smartCheck.data, "", 0);
      }
      console.log("New Blob from ArrayBuffer:", blob);
    });
  };

  const uploadOpen = () => {
    const fileInput = document.getElementById("uploadaudio").click();
  };

  return (
    <Box
      sx={{
        backgroundImage: "url(./mainbackground.svg)",
        backgroundSize: "cover",
        height: "100vh",
      }}
    >
      <Grid container>
        <Box
           
          sx={{
            backgroundColor: "#FFFFFF",
            margin: 2,
            height: "90vh",
            borderRadius: 5,
            boxShadow: 10,
            padding: 2,
            overflow: "auto",
          }}
        >
          {/* <Grid item sm={12} md={12}> */}
          {/* <Grid container sx={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', borderBottom: 'solid #DB8829', borderBottomStyle: 'double' }}>
                            <Grid sm={8} md={8} item sx={{ display: 'flex' }}> */}
          {/* <img
                                    src='/logo.png'
                                    alt='Vocablab'
                                    loading="lazy"
                                    width='8%'
                                /> */}
          {/* <Typography sx={{
                                    mt: 1, color: 'primary.main', fontWeight: '900', fontSize: '1.6rem', '@media (min-width: 1636px)': {
                                        fontSize: '3rem'
                                    }
                                }}>
                                    AI Test
                                </Typography>
                            </Grid>
                            <Grid sm={4} md={4} item sx={{ textAlign: 'right', pr: 4 }}>
                                <img
                                    src='/words_full.png'
                                    alt='Vocablab'
                                    loading="lazy"
                                    width='14%'
                                />
                            </Grid>
                        </Grid> */}
          {/* </Grid> */}
          <Grid container sx={{ mt: 4 }}>
            <Grid item md={12} sm={12}>
              <Box sx={{ textAlign: "center" }}>
                <img
                  src={require('../../assets/words_full.png')}
                  alt="Vocablab"
                  loading="lazy"
                  width="12%"
                />
                <Typography className={classes.className1} sx={{}}>
                  <b>Linguistic Insight Engine</b>
                </Typography>
                <Typography className={classes.className} sx={{}}>
                  <b>Assessment for English Language Proficiency</b>
                </Typography>
                <Typography
                  className={classes.ModuleNum}
                  sx={{ lineHeight: 1 }}
                >
                  00:{twoDigit(timerClock)}
                  <TimerIcon
                    sx={{ ml: 2, fontSize: "2rem !important" }}
                  ></TimerIcon>
                </Typography>
              </Box>
              <Box
                sx={{
                  justifyContent: "center",
                  my: 2,
                  display: "flex",
                }}
              >
                <RecordButtonOpen
                  startRecord={(flg) => {
                    startInterval(flg);
                  }}
                  textToCheck={""}
                  alreadyRecorded={
                    localAudios.length > 0 && localAudios[0]
                      ? localAudios[0]
                      : null
                  }
                  recordedAudio={(audio) => {
                    setAudioLinks(audio, 0);
                  }}
                  smartCheck={(data, filename) => {
                    setSmartCheck(data, filename, 0);
                  }}
                  uploadedAudioName={(filename) => {
                    setFiles(filename, 0);
                  }}
                  checkOnPause={aiEnable}
                  resetComponent={true}
                  numberOfAttemptes={1}
                  unscripted={unscripted}
                  index={0}
                  disabled={
                    smartCheckResult &&
                    smartCheckResult.length > 0 &&
                    smartCheckResult[0]
                  }
                ></RecordButtonOpen>
                <IconButton
                  sx={{
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                    mx: 2,
                    backgroundColor: "#DB8829",
                    color: "white",
                   
                  }}
                  onClick={uploadOpen}
                >
                  <CloudUploadIcon />
                </IconButton>
              </Box>
              <Box sx={{ textAlign: "center" }} id="pdfid">
                {!(
                  smartCheckResult &&
                  smartCheckResult.length > 0 &&
                  smartCheckResult[0] &&
                  aiEnable
                ) && (
                  <Grid
                    container
                    sx={{ mt: 4 }}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Grid item md={6} sm={6}>
                      <Box>
                        <Typography
                          variant="body1"
                          fontWeight={"500"}
                          sx={{ color: "primary.main" }}
                        >
                          This is an automated AI powered English language
                          assessment.
                        </Typography>
                        <Typography
                          variant="body1"
                          fontWeight={"500"}
                          sx={{ color: "primary.main" }}
                        >
                          Kindly record your thoughts on any topics of your
                          choice for 20 to 30 seconds. See your result
                          instantenously.
                        </Typography>
                        <Typography
                          variant="body1"
                          mt={1}
                          fontWeight={"500"}
                          sx={{ color: "primary.main" }}
                        >
                          We will email the softcopy of the result to you within
                          3 working days.
                        </Typography>
                        <Typography
                          variant="body1"
                          mt={1}
                          fontWeight={"500"}
                          sx={{ color: "primary.main" }}
                        >
                          Good Luck!
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                )}
                {smartCheckResult &&
                  smartCheckResult.length > 0 &&
                  smartCheckResult[0] &&
                  aiEnable && (
                    <Grid container sx={{ pa: 0, width: "100%" }}>
                      <SmartCheckCardOpen
                        smartCheckResult={smartCheckResult[0]}
                        unscripted={unscripted}
                        name={userData.name}
                        schoolName={userData.schoolName}
                        email={userData.email}
                        hidePronoun={hidePronoun}
                      ></SmartCheckCardOpen>
                    </Grid>
                  )}
              </Box>
              {smartCheckResult &&
                smartCheckResult.length > 0 &&
                smartCheckResult[0] &&
                aiEnable && (
                  <Box sx={{ textAlign: "center" }}>
                    <div style={{ marginTop: "2rem" }}>
                      <Button
                        variant="contained"
                        size="large"
                        sx={{ fontSize: "1.2rem", fontWeight: "bold", mx: 1 }}
                        startIcon={<DownloadIcon />}
                        onClick={() => {
                          setHidePronoun(true);
                          setTimeout(() => {
                            setHidePronoun(false);
                          }, 2000);
                          downloadPDF();
                        }}
                      >
                        Download Your Report
                      </Button>
                      {/* <Button
                    variant="contained"
                    size="large"
                    sx={{
                      fontSize: "1.2rem",
                      fontWeight: "bold",
                      mx: 2,
                      px: 6,
                    }}
                    startIcon={<PrintIcon />}
                  >
                    Print
                  </Button> */}
                    </div>
                  </Box>
                )}
            </Grid>
          </Grid>
        </Box>
        <input
          type="file"
          id="uploadaudio"
          style={{ visibility: "hidden" }}
          onChange={fileChange}
        ></input>
        <AITestGuestInfo
          visible={infoModl}
          //visible={false}
          persistent={true}
          toggleModal={(flag) => setInfoModl(flag)}
          go={(allData) => {
            saveData(allData);
          }}
        ></AITestGuestInfo>
      </Grid>
    </Box>
  );
};
const useStyles = makeStyles({
  card: {
    // backgroundColor: "#fff",
    // width: '32rem',
    // height: '36rem',
    borderRadius: 17,
    // shadowColor: "#000",
    // boxShadow: "2rem",
    textAlign: "center",
  },
  ModuleNum: {
    textAlign: "center",
    fontWeight: "900",
    color: "#DB8829",
    fontSize: "3rem",
    marginTop: "2%",
  },
  ModuleName: {
    fontSize: "1.4rem",
    textAlign: "center",
    fontWeight: "600",
    paddingBottom: 10,
  },
  cardText: {
    fontSize: "0.9rem",
    textAlign: "center",
    paddingTop: 10,
    fontWeight: "500",
  },
  className1: {
    borderRadius: 20,
    textAlign: "center",
    color: "#DB8829",
    fontSize: "1.8rem",
    // backgroundColor: '#F5F7FF',
    fontWeight: "500",
    marginTop: "2%",
  },
  className: {
    borderRadius: 20,
    textAlign: "center",
    color: "#DB8829",
    fontSize: "1.2rem",
    // backgroundColor: '#F5F7FF',
    fontWeight: "500",
    marginTop: "2%",
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
      textAlign: "left",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
   
  },
});

export default AITest;
